import { render, staticRenderFns } from "./ModalOrganization.vue?vue&type=template&id=1f2be439&scoped=true&"
import script from "./ModalOrganization.vue?vue&type=script&lang=js&"
export * from "./ModalOrganization.vue?vue&type=script&lang=js&"
import style0 from "./ModalOrganization.vue?vue&type=style&index=0&id=1f2be439&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f2be439",
  null
  
)

export default component.exports